import { EInsiderPageType } from 'core/model/enums/insider.enum';

export const INSIDER_STANDARD_TYPES: Array<EInsiderPageType> = [
  EInsiderPageType.HOME,
  EInsiderPageType.PRODUCT,
  EInsiderPageType.CATEGORY,
  EInsiderPageType.BASKET,
  EInsiderPageType.CONFIRMATION,
] as const;
